import React, { useState, useEffect } from 'react'
import './FullSchedule.css'
import { useParams, Link } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'

const FullSchedule = () => {
	console.log('inside FullSchedule.js')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allGamesAndEvents, setAllGamesAndEvents] = useState([])

	useEffect(() => {
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/allGamesAndEvents'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllGamesAndEvents(responseData.allItems)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	let distinctVenues
	let distinctVenuesArray
	distinctVenuesArray = []

	if (allGamesAndEvents.length !== 0) {
		distinctVenues = [...new Set(allGamesAndEvents.map((x) => x.venueName))]
		for (let i = 0; i < distinctVenues.length; i++) {
			distinctVenuesArray.push(distinctVenues[i])
		}
	}

	let dateBlock
	dateBlock = []
	if (!isLoading && allGamesAndEvents.length === 0) {
		return (
			<React.Fragment>
				{/* <AdminNavigation /> */}
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (!isLoading && allGamesAndEvents.length !== 0 && distinctVenuesArray) {
		distinctVenuesArray.forEach((venue) => {
			dateBlock.push(
				<div className='FullSchedule'>
					{/* <AdminNavigation /> */}
					<h1>{venue}</h1>
					<table id='defaultScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								<th>League</th>
								{/* <th>Division</th> */}
								<th>Visitor/Home</th>
								<th></th>
								<th>Winner</th>
								<th>Score</th>
								{/* <th>Venue</th> */}
							</tr>
						</thead>
						<tbody>
							{allGamesAndEvents.map((game, key) => {
								if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												<br></br>
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am'}
											</td>
											<td>
												{(game.leagueName && game.leagueName) || game.eventName}
											</td>
											{/* <td>
												{(game.status && game.status !== 'TBP' && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														{game.status}
													</Link>
												)) ||
													'TBP'}
											</td> */}
											{/* <td>{game.divisionName}</td> */}
											{game.visitorTeamName && (
												<td>
													{game.visitorTeamSeed > 0 &&
														'(' + game.visitorTeamSeed + ') '}
													{game.visitorTeamName && game.visitorTeamName}
													<br></br>
													{' @ '}
													<br></br>
													{game.homeTeamSeed > 0 &&
														'(' + game.homeTeamSeed + ') '}
													{game.homeTeamName && game.homeTeamName}
												</td>
											)}
											{game.eventName && (
												<td
													style={{
														fontWeight: 'bold',
														backgroundColor: 'pink',
													}}
												>
													{game.eventName}
												</td>
											)}
											{!game.playoff && !game.championship && <td></td>}
											{game.playoff && (
												<td style={{ color: 'red', fontWeight: 'bold' }}>
													{game.description}
												</td>
											)}

											{game.championship && (
												<td style={{ color: 'red', fontWeight: 'bold' }}>
													CHAMPIONSHIP GAME
												</td>
											)}
											{game.homeTeamId && game.winner === game.homeTeamId && (
												<td>{game.homeTeamName}</td>
											)}
											{game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>{game.visitorTeamName}</td>
												)}
											{game.status &&
												game.status !== 'TBP' &&
												game.winner !== game.homeTeamId &&
												game.winner !== game.visitorTeamId && <td>TIE</td>}
											{!game.score && <td></td>}
											<td>
												{game.score && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														{game.score}
														{game.status === 'Overtime' && ' (OT)'}
														{game.status === 'Shootout' && ' (SO)'}
													</Link>
												)}
											</td>
										</tr>
									)
								}
							})}
						</tbody>
					</table>
				</div>
			)
		})
	}

	return (
		<React.Fragment>
			{dateBlock && dateBlock}
			<Footer />
		</React.Fragment>
	)
}

export default FullSchedule
